var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.categories.length>0)?_c('Header'):_vm._e(),(_vm.categories.length>0)?_c('router-view',{staticClass:"content"}):_vm._e(),_c('Footer'),_c('LoginDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }